import { render, staticRenderFns } from "./SubCategoryDropdown.vue?vue&type=template&id=7151d198&"
import script from "./SubCategoryDropdown.vue?vue&type=script&lang=js&"
export * from "./SubCategoryDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports